/**
 * ============================================
 * NESSUNSE CART VALIDATOR v6.0
 * ============================================
 *
 * APPROCCIO DOPPIO:
 *   A) Intercetta fetch/XHR/form PRIMA dell'add → blocca se possibile
 *   B) Watcher DOPO ogni add → se qualcosa sfugge, lo rimuove dal carrello
 *
 * CHANGELOG v6.0:
 *   - ANIMAL aggiornato: 3 varianti (1/2/3 animali) mappate su handle 'nessunse-animal'
 *     → automaticamente bloccate come duplicati se si prova ad aggiungerne più di una
 *   - Rimosso completamente 'animale-add-on' (Opzione Animal) — non previsto da contratto
 *   - Aggiunte ALLOWED_EXTRAS per ANIMAL (solo RC Capofamiglia, come da contratto)
 *
 * REGOLE:
 *   1. Un solo prodotto per tipologia (no duplicati, qty sempre = 1)
 *   2. ME ↔ FAMILY incompatibili
 *   3. Extra permessi solo se TUTTI i piani nel carrello li supportano:
 *      - ME:       rc-capofamiglia, tutela-lavoro, soccorso-stradale
 *      - FAMILY:   rc-capofamiglia, tutela-lavoro, soccorso-stradale
 *      - JOB:      rc-capofamiglia, tutela-circolazione, soccorso-stradale
 *      - DRIVER:   rc-capofamiglia, tutela-lavoro, soccorso-stradale
 *      - BUSINESS: rc-capofamiglia, soccorso-stradale
 *      - ANIMAL:   rc-capofamiglia
 * ============================================
 */

(function () {
  'use strict';

  if (window.__NessunSEV6__) return;
  window.__NessunSEV6__ = true;

  // ============================================
  // FETCH ORIGINALE
  // ============================================
  var _fetch = window.fetch.bind(window);

  // ============================================
  // CONFIG
  // ============================================
  var VARIANT_MAP = {
    // Piani principali
    52189419831562: 'nessunse-mia',
    52198644711690: 'nessunse-family',
    52199314063626: 'nessunse-job',
    52199283065098: 'nessunse-driver',
    // BUSINESS - 3 plafond → stesso handle (bloccati come duplicati tra loro)
    52253160046858: 'nessunse-business-1',
    52253160112394: 'nessunse-business-1',
    52253160145162: 'nessunse-business-1',
    // ANIMAL - 3 livelli (1/2/3 animali) → stesso handle (bloccati come duplicati tra loro)
    53079033315594: 'nessunse-animal',
    53079033381130: 'nessunse-animal',
    53079033413898: 'nessunse-animal',
    // Extras
    52281710903562: 'rc-capofamiglia',
    52281726959882: 'tutela-diritto-del-lavoro',
    52281741836554: 'soccorso-stradale',
    52281778471178: 'tutela-circolazione-stradale-nautica'
  };

  var CORES = [
    'nessunse-mia','nessunse-family','nessunse-driver',
    'nessunse-job','nessunse-business-1','nessunse-animal'
  ];

  var EXTRAS = [
    'rc-capofamiglia','tutela-diritto-del-lavoro',
    'tutela-circolazione-stradale-nautica','soccorso-stradale'
  ];

  var INCOMPATIBLE = [
    ['nessunse-mia', 'nessunse-family']
  ];

  var ALLOWED_EXTRAS = {
    'nessunse-mia':        ['rc-capofamiglia', 'tutela-diritto-del-lavoro', 'soccorso-stradale'],
    'nessunse-family':     ['rc-capofamiglia', 'tutela-diritto-del-lavoro', 'soccorso-stradale'],
    'nessunse-job':        ['rc-capofamiglia', 'tutela-circolazione-stradale-nautica', 'soccorso-stradale'],
    'nessunse-driver':     ['rc-capofamiglia', 'tutela-diritto-del-lavoro', 'soccorso-stradale'],
    'nessunse-business-1': ['rc-capofamiglia', 'soccorso-stradale'],
    'nessunse-animal':     ['rc-capofamiglia']
  };

  var NAMES = {
    'nessunse-mia': 'NessunSE ME',
    'nessunse-family': 'NessunSE FAMILY',
    'nessunse-driver': 'NessunSE DRIVER',
    'nessunse-job': 'NessunSE JOB',
    'nessunse-business-1': 'NessunSE BUSINESS',
    'nessunse-animal': 'NessunSE ANIMAL',
    'rc-capofamiglia': 'RC Capofamiglia',
    'tutela-diritto-del-lavoro': 'Tutela Diritto del Lavoro',
    'tutela-circolazione-stradale-nautica': 'Tutela Circolazione Stradale',
    'soccorso-stradale': 'Soccorso Stradale'
  };

  // ============================================
  // HELPERS
  // ============================================
  function handle4variant(vid) { return VARIANT_MAP[vid] || null; }

  function handle4item(item) {
    if (item.variant_id && VARIANT_MAP[item.variant_id]) return VARIANT_MAP[item.variant_id];
    var h = item.handle || item.product_handle || '';
    if (CORES.indexOf(h) !== -1 || EXTRAS.indexOf(h) !== -1) return h;
    return '';
  }

  function n(h) { return NAMES[h] || h; }
  function isCore(h) { return CORES.indexOf(h) !== -1; }
  function isExtra(h) { return EXTRAS.indexOf(h) !== -1; }
  function isKnown(h) { return isCore(h) || isExtra(h); }

  // ============================================
  // TOAST NOTIFICATIONS
  // ============================================
  var _container = null;
  var _cssOk = false;

  function injectCSS() {
    if (_cssOk) return;
    _cssOk = true;
    var s = document.createElement('style');
    s.textContent = [
      '@keyframes nseIn{0%{transform:translateX(460px) scale(.9);opacity:0}100%{transform:translateX(0) scale(1);opacity:1}}',
      '@keyframes nseOut{0%{transform:translateX(0) scale(1);opacity:1}100%{transform:translateX(460px) scale(.9);opacity:0}}',
      '@keyframes nseGlow{0%,100%{box-shadow:0 6px 24px rgba(95,207,134,.25)}50%{box-shadow:0 6px 32px rgba(95,207,134,.5)}}',
      '@keyframes nseBounce{0%{transform:scale(1)}25%{transform:scale(1.18)}50%{transform:scale(.93)}100%{transform:scale(1)}}',
      '@keyframes nseBar{0%{width:100%}100%{width:0}}',
      '#nse-box{position:fixed;top:16px;right:16px;z-index:999999;max-width:400px;pointer-events:none;display:flex;flex-direction:column;gap:10px}',
      '.nse-t{pointer-events:auto;display:flex;align-items:flex-start;gap:12px;padding:16px 16px 14px;border-radius:16px;' +
        'background:linear-gradient(135deg,#1b454f 0%,#2a6070 55%,#1b454f 100%);' +
        'color:#fff;font-family:"Reddit Sans","Inter",system-ui,sans-serif;' +
        'box-shadow:0 6px 24px rgba(27,69,79,.3),0 2px 6px rgba(0,0,0,.08);' +
        'animation:nseIn .45s cubic-bezier(.22,1,.36,1),nseGlow 2.5s ease .8s 2;' +
        'cursor:pointer;border:1px solid rgba(255,255,255,.12);position:relative;overflow:hidden;' +
        'transition:transform .12s,box-shadow .12s}',
      '.nse-t:hover{transform:scale(1.01);box-shadow:0 8px 28px rgba(27,69,79,.4)}',
      '.nse-t.warn{background:linear-gradient(135deg,#5fcf86 0%,#4aba72 55%,#3da563 100%);box-shadow:0 6px 24px rgba(95,207,134,.3)}',
      '.nse-t.warn:hover{box-shadow:0 8px 28px rgba(95,207,134,.4)}',
      '.nse-t.warn .nse-i{background:rgba(255,255,255,.2)}',
      '.nse-t.warn .nse-bar{background:rgba(255,255,255,.25)}',
      '.nse-t-out{animation:nseOut .35s cubic-bezier(.22,1,.36,1) forwards!important}',
      '.nse-i{flex-shrink:0;width:40px;height:40px;border-radius:12px;background:rgba(255,255,255,.16);display:flex;align-items:center;justify-content:center;animation:nseBounce .5s ease .15s}',
      '.nse-i svg{width:22px;height:22px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}',
      '.nse-b{flex:1;min-width:0}',
      '.nse-lbl{font-weight:700;font-size:11.5px;text-transform:uppercase;letter-spacing:.6px;opacity:.75;margin-bottom:3px}',
      '.nse-msg{font-weight:500;font-size:14.5px;line-height:1.45}',
      '.nse-x{flex-shrink:0;width:26px;height:26px;border-radius:50%;background:rgba(255,255,255,.12);border:none;color:#fff;font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .12s;padding:0;line-height:1;margin-top:-2px}',
      '.nse-x:hover{background:rgba(255,255,255,.28)}',
      '.nse-bar{position:absolute;bottom:0;left:0;height:3px;background:rgba(95,207,134,.4);border-radius:0 0 16px 16px;animation:nseBar 7s linear forwards}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function getContainer() {
    injectCSS();
    if (_container && document.body.contains(_container)) return _container;
    _container = document.createElement('div');
    _container.id = 'nse-box';
    document.body.appendChild(_container);
    return _container;
  }

  // Icona scudo (per messaggi normali)
  var SVG_SHIELD = '<svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';
  // Icona info cerchio (per incompatibilità/warning - friendly, no pericolo)
  var SVG_INFO   = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';

  function toast(msg, type, title) {
    var box = getContainer();
    var all = box.querySelectorAll('.nse-t');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-m') === msg) return;
    }
    var isWarn = (type === 'incompatible' || type === 'warning' || type === 'not-allowed');
    var icon = isWarn ? SVG_INFO : SVG_SHIELD;
    var el = document.createElement('div');
    el.className = 'nse-t' + (isWarn ? ' warn' : '');
    el.setAttribute('data-m', msg);
    el.innerHTML =
      '<div class="nse-i">' + icon + '</div>' +
      '<div class="nse-b"><div class="nse-lbl">' + (title||'Attenzione') + '</div><div class="nse-msg">' + msg + '</div></div>' +
      '<button class="nse-x" aria-label="Chiudi">&times;</button>' +
      '<div class="nse-bar"></div>';
    function kill() {
      el.classList.add('nse-t-out');
      setTimeout(function(){ if(el.parentNode) el.remove(); }, 350);
    }
    el.querySelector('.nse-x').addEventListener('click', function(e){ e.stopPropagation(); kill(); });
    el.addEventListener('click', kill);
    box.appendChild(el);
    setTimeout(function(){ if(el.parentNode) kill(); }, 7000);
  }

  // ============================================
  // CART STATE
  // ============================================
  var cartItems = [];
  var cartSet = new Set();
  var loadingState = false;

  async function loadCart() {
    if (loadingState) return;
    loadingState = true;
    try {
      var r = await _fetch('/cart.js', {credentials:'same-origin'});
      var c = await r.json();
      cartItems = (c && c.items) ? c.items : [];
      cartSet.clear();
      cartItems.forEach(function(item){
        var h = handle4item(item);
        if (h && isKnown(h)) cartSet.add(h);
      });
      console.log('[NSE6] Cart:', Array.from(cartSet));
    } catch(e) {
      console.error('[NSE6] Load error:', e);
    }
    loadingState = false;
  }

  function getCoresInCart() {
    var cores = [];
    cartSet.forEach(function(h) {
      if (isCore(h)) cores.push(h);
    });
    return cores;
  }

  function isExtraAllowedByPlans(extraHandle, coresInCart) {
    if (coresInCart.length === 0) return true;
    for (var i = 0; i < coresInCart.length; i++) {
      var allowed = ALLOWED_EXTRAS[coresInCart[i]];
      if (!allowed) return false;
      if (allowed.indexOf(extraHandle) === -1) return false;
    }
    return true;
  }

  function findBlockingPlan(extraHandle, coresInCart) {
    for (var i = 0; i < coresInCart.length; i++) {
      var allowed = ALLOWED_EXTRAS[coresInCart[i]];
      if (!allowed || allowed.indexOf(extraHandle) === -1) {
        return coresInCart[i];
      }
    }
    return null;
  }

  // ============================================
  // VALIDATE
  // ============================================
  function check(handle) {
    if (!handle || !isKnown(handle)) return {ok:true};

    if (cartSet.has(handle)) {
      return {ok:false, msg: n(handle)+' è già nel carrello. Ogni prodotto può essere acquistato una sola volta.', type:'duplicate', title:'Già nel carrello'};
    }

    if (isCore(handle)) {
      for (var g=0; g<INCOMPATIBLE.length; g++) {
        var grp = INCOMPATIBLE[g];
        if (grp.indexOf(handle)===-1) continue;
        for (var p=0; p<grp.length; p++) {
          if (grp[p]!==handle && cartSet.has(grp[p])) {
            return {ok:false, msg: n(handle)+' non è combinabile con '+n(grp[p])+'. Rimuovi prima '+n(grp[p])+' dal carrello.', type:'incompatible', title:'Non combinabili'};
          }
        }
      }
    }

    if (isExtra(handle)) {
      var cores = getCoresInCart();
      if (!isExtraAllowedByPlans(handle, cores)) {
        var blocker = findBlockingPlan(handle, cores);
        var msg = n(handle) + ' non è disponibile con il piano ' + n(blocker) + '.';
        return {ok:false, msg: msg, type:'not-allowed', title:'Extra non compatibile'};
      }
    }

    return {ok:true};
  }

  // ============================================
  // EXTRACT VARIANT IDS
  // ============================================
  function getIds(body) {
    var ids = [];
    if (!body) return ids;
    try {
      var d;
      if (typeof body==='string') {
        var t = body.trim();
        if (t.charAt(0)==='{'||t.charAt(0)==='[') {
          d = JSON.parse(t);
        } else {
          var p = new URLSearchParams(t);
          var si = p.get('id');
          if (si) ids.push(parseInt(si,10));
          p.forEach(function(v,k){ if(k.indexOf('items')!==-1&&k.indexOf('id')!==-1) ids.push(parseInt(v,10)); });
          return ids.filter(function(x){return !isNaN(x);});
        }
      } else if (typeof FormData!=='undefined' && body instanceof FormData) {
        var fi = body.get('id');
        if (fi) ids.push(parseInt(fi,10));
        body.getAll('items[][id]').forEach(function(v){ ids.push(parseInt(v,10)); });
        return ids.filter(function(x){return !isNaN(x);});
      } else {
        d = body;
      }
      if (d) {
        if (d.id) ids.push(parseInt(d.id,10));
        if (d.items && Array.isArray(d.items)) d.items.forEach(function(it){ if(it.id) ids.push(parseInt(it.id,10)); });
      }
    } catch(e){}
    return ids.filter(function(x){return !isNaN(x);});
  }

  // ============================================
  // INTERCEPT FETCH
  // ============================================
  var locked = false;

  window.fetch = async function() {
    var url = arguments[0];
    var opts = arguments[1] || {};
    var isAdd = (typeof url==='string') && url.indexOf('/cart/add')!==-1 && url.indexOf('/cart/change')===-1;
    if (!isAdd) return _fetch.apply(window, arguments);

    if (locked) {
      await new Promise(function(resolve){
        var iv=setInterval(function(){ if(!locked){clearInterval(iv);resolve();} },40);
      });
    }
    locked = true;

    try {
      await loadCart();
      var ids = getIds(opts.body);
      console.log('[NSE6] fetch /cart/add ids:', ids);

      for (var i=0; i<ids.length; i++) {
        var h = handle4variant(ids[i]);
        if (!h) continue;
        var r = check(h);
        if (!r.ok) {
          console.log('[NSE6] ❌ PRE-BLOCK:', h, r.msg);
          toast(r.msg, r.type, r.title);
          locked = false;
          return new Response(JSON.stringify({status:422,message:r.msg}), {status:422, headers:{'Content-Type':'application/json'}});
        }
      }

      var resp = await _fetch.apply(window, arguments);
      setTimeout(function(){ enforceRules('post-fetch-add'); }, 300);
      return resp;
    } finally {
      locked = false;
    }
  };

  // ============================================
  // INTERCEPT XHR
  // ============================================
  var _xOpen = XMLHttpRequest.prototype.open;
  var _xSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(m,u) { this.__nseUrl=u; return _xOpen.apply(this,arguments); };
  XMLHttpRequest.prototype.send = function(body) {
    var xhr=this, url=xhr.__nseUrl||'';
    if (url.indexOf('/cart/add')!==-1 && url.indexOf('/cart/change')===-1) {
      var ids = getIds(body);
      for (var i=0; i<ids.length; i++) {
        var h = handle4variant(ids[i]);
        if (!h) continue;
        var r = check(h);
        if (!r.ok) {
          console.log('[NSE6] ❌ XHR BLOCK:', h);
          toast(r.msg, r.type, r.title);
          setTimeout(function(){ try{xhr.abort();}catch(e){} },0);
          return;
        }
      }
      var orig_onload = xhr.onload;
      xhr.onload = function() {
        if (orig_onload) orig_onload.apply(this, arguments);
        setTimeout(function(){ enforceRules('post-xhr-add'); }, 300);
      };
    }
    return _xSend.apply(this,arguments);
  };

  // ============================================
  // INTERCEPT FORM SUBMIT
  // ============================================
  document.addEventListener('submit', function(e) {
    var f = e.target;
    if (!f||!f.action||f.action.indexOf('/cart/add')===-1) return;
    var inp = f.querySelector('[name="id"]');
    if (!inp) return;
    var h = handle4variant(parseInt(inp.value,10));
    if (!h) return;
    var r = check(h);
    if (!r.ok) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      toast(r.msg, r.type, r.title);
    }
  }, true);

  // ============================================
  // ENFORCE RULES (post-add watcher)
  // ============================================
  var enforcing = false;

  async function enforceRules(source) {
    if (enforcing) return;
    enforcing = true;

    try {
      var r = await _fetch('/cart.js', {credentials:'same-origin'});
      var cart = await r.json();
      if (!cart||!cart.items||cart.items.length===0) { enforcing=false; await loadCart(); return; }

      console.log('[NSE6] enforceRules da:', source, '- items:', cart.items.length);

      var byHandle = {};
      var coresPresent = [];
      var ops = [];

      cart.items.forEach(function(item) {
        var h = handle4item(item);
        if (!h || !isKnown(h)) return;
        if (!byHandle[h]) byHandle[h] = [];
        byHandle[h].push(item);
        if (isCore(h) && coresPresent.indexOf(h)===-1) coresPresent.push(h);
      });

      Object.keys(byHandle).forEach(function(h) {
        var items = byHandle[h];
        for (var i=1; i<items.length; i++) {
          ops.push({key:items[i].key, h:h, reason:'duplicate', qty:0});
        }
        if (items[0].quantity > 1) {
          ops.push({key:items[0].key, h:h, reason:'qty', qty:1});
        }
      });

      INCOMPATIBLE.forEach(function(group) {
        var found = [];
        cart.items.forEach(function(item) {
          var h = handle4item(item);
          if (group.indexOf(h)!==-1 && found.indexOf(h)===-1) found.push(h);
        });
        for (var i=1; i<found.length; i++) {
          if (byHandle[found[i]]) {
            byHandle[found[i]].forEach(function(item) {
              ops.push({key:item.key, h:found[i], conflict:found[0], reason:'incompatible', qty:0});
            });
          }
        }
      });

      Object.keys(byHandle).forEach(function(h) {
        if (!isExtra(h)) return;
        if (!isExtraAllowedByPlans(h, coresPresent)) {
          var blocker = findBlockingPlan(h, coresPresent);
          byHandle[h].forEach(function(item) {
            ops.push({key:item.key, h:h, blocker:blocker, reason:'not-allowed', qty:0});
          });
        }
      });

      var seen = {};
      ops = ops.filter(function(op){ if(seen[op.key]) return false; seen[op.key]=true; return true; });

      if (ops.length === 0) {
        console.log('[NSE6] ✅ Carrello OK');
        enforcing = false;
        await loadCart();
        return;
      }

      console.log('[NSE6] 🧹', ops.length, 'operazioni');

      for (var i=0; i<ops.length; i++) {
        var op = ops[i];
        console.log('[NSE6] →', op.reason, n(op.h), 'key:', op.key, 'qty:', op.qty);

        await _fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          credentials:'same-origin',
          body: JSON.stringify({id:op.key, quantity:op.qty})
        });

        if (op.reason === 'duplicate') {
          toast(n(op.h)+' è già nel carrello. Ogni prodotto può essere acquistato una sola volta.', 'duplicate', 'Già nel carrello');
        } else if (op.reason === 'not-allowed') {
          toast(n(op.h)+' non è disponibile con il piano '+n(op.blocker)+'.', 'not-allowed', 'Extra non compatibile');
        } else if (op.reason === 'incompatible') {
          toast(n(op.h)+' non è combinabile con '+n(op.conflict)+'.', 'incompatible', 'Non combinabili');
        }
      }

      refreshUI();

    } catch(e) {
      console.error('[NSE6] enforceRules error:', e);
    }

    enforcing = false;
    await loadCart();
  }

  // ============================================
  // REFRESH UI
  // ============================================
  function refreshUI() {
    if (window.location.pathname.indexOf('/cart')!==-1) {
      setTimeout(function(){ window.location.reload(); }, 500);
      return;
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      _fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count],.header__cart-count,.cart-item-count')
          .forEach(function(el){ el.textContent = c.item_count; });
      });
    } catch(e){}
  }

  // ============================================
  // WATCHER CONTINUO
  // ============================================
  function startWatcher() {
    setInterval(function() {
      if (locked || enforcing) return;
      var vis = window.location.pathname.indexOf('/cart')!==-1 ||
        document.querySelector('.cart-drawer.active,.cart-drawer.open,.minicart.open,.minicart.active');
      if (vis) enforceRules('poll');
    }, 2000);

    var obs = new MutationObserver(function() {
      if (locked || enforcing) return;
      var d = document.querySelector('.cart-drawer,.minicart,[data-cart-drawer]');
      if (d && (d.classList.contains('active') || d.classList.contains('open'))) {
        setTimeout(function(){ enforceRules('drawer-open'); }, 300);
      }
    });
    if (document.body) obs.observe(document.body, {attributes:true, subtree:true, attributeFilter:['class']});

    if (typeof PerformanceObserver !== 'undefined') {
      try {
        var perfObs = new PerformanceObserver(function(list) {
          var entries = list.getEntries();
          for (var i=0; i<entries.length; i++) {
            if (entries[i].name && entries[i].name.indexOf('/cart/add')!==-1) {
              setTimeout(function(){ enforceRules('perf-observer'); }, 500);
              break;
            }
          }
        });
        perfObs.observe({entryTypes: ['resource']});
      } catch(e) {}
    }

    var lastCartToken = document.cookie.match(/cart=([^;]+)/);
    lastCartToken = lastCartToken ? lastCartToken[1] : '';
    setInterval(function() {
      if (locked || enforcing) return;
      var current = document.cookie.match(/cart=([^;]+)/);
      current = current ? current[1] : '';
      if (current !== lastCartToken) {
        lastCartToken = current;
        setTimeout(function(){ enforceRules('cookie-change'); }, 400);
      }
    }, 1000);
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    console.log('[NSE6] ✅ Cart Validator v6.0 — ANIMAL aggiornato + Opzione Animal rimossa');
    console.log('[NSE6] Regole: no duplicati | ME↔FAMILY | extra permessi per piano | ANIMAL standalone');
    loadCart();
    startWatcher();
    setTimeout(function(){ enforceRules('init'); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
